import { createBrowserHistory } from 'history';
import appConfig from '../../config';
const history = createBrowserHistory({
  basename: appConfig.basePath || ''
});
export default history;